/* eslint-disable no-case-declarations */
import * as mainActionTypes from '../mainActionTypes';

export default function namesReducer(state = null, action) {
  const { type, payload } = action;
  let newState = state;
  switch (type) {
    case mainActionTypes.REMOVE_NAME:
      const arrOfNames = [...state];
      const indexToRemove = payload;
      arrOfNames.splice(indexToRemove, 1);
      newState = arrOfNames;
      break;

    case mainActionTypes.SORT_NAMES:
      const names = [...state];
      const typeOfSorting = payload;
      const sortNames = names.sort((a, b) => {
        if (typeOfSorting === 'bestMatch') {
          return a.rank <= b.rank ? -1 : 1;
        } else {
          const nameA = a.text.toLowerCase();
          const nameB = b.text.toLowerCase();
          let compareElem = 0;
          if (nameA.length < nameB.length) {
            compareElem = typeOfSorting === 'asc' ? -1 : 1;
          } else if (nameA.length > nameB.length) {
            compareElem = typeOfSorting === 'asc' ? 1 : -1;
          }
          return compareElem;
        }
      });
      newState = sortNames;
      break;

    case mainActionTypes.LIKED_NAME:
      const arrNamesList = [...state];
      const indexLiked = payload;
      const nameIsLiked = arrNamesList[indexLiked].isLiked;
      arrNamesList[indexLiked].isLiked = !nameIsLiked;
      newState = arrNamesList;
      break;

    case mainActionTypes.SET_DOMAIN_NAME:
      const currentNames = [...state];
      const { index, domain } = payload;
      currentNames[index].domain = domain;
      newState = currentNames;
      break;

    case mainActionTypes.SET_NAMES_LIST:
      newState = payload;
      break;

    default:
  }
  return newState;
}
